import { CanDowngrade } from "../CanDowngrade";
import {
  useUpgradeFlowFormContext,
  useUpgradeFlowShellContext,
} from "../UpgradeFlowContext";
import { useUpgradePlanContext } from "../UpgradePlanContext";

export const CanDowngradeRoute = () => {
  const { modal } = useUpgradeFlowShellContext();
  const { handleChangePlan } = useUpgradeFlowFormContext();
  const { plan } = useUpgradePlanContext();

  return (
    <CanDowngrade
      plan={plan}
      changePlan={handleChangePlan}
      hideModal={modal.hide}
    />
  );
};
